module.exports = __webpack_public_path__ + "static/img/1_1_3_2.1be54356.jpg";